import { Text } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import {
  EMPTY_BUDGET_NOTIFICATION,
  type BudgetNotificationSettings,
} from 'typings'
import { Collapsible } from '../../../../Collapsible'
import { messages } from './messages'
import { NotificationContent } from './NotificationContent'
import { NotificationHeader } from './NotificationHeader'
import { styles } from './styles'

type BudgetNotificationProps = {
  name: string
  form: FormState
  onOpen: () => void
  notificationDraft: BudgetNotificationSettings | null
  setNotificationDraft: (draft: BudgetNotificationSettings | null) => void
}

export function BudgetNotification(props: BudgetNotificationProps) {
  const { name, form, onOpen, notificationDraft, setNotificationDraft } = props

  const enable: boolean = useWatch({ form, name: `${name}.enable` })

  const handleEnable = (nextEnable: boolean) => {
    if (!nextEnable) {
      const current: BudgetNotificationSettings = form.getValues(name)
      setNotificationDraft(current)
      form.setValue(name, { ...EMPTY_BUDGET_NOTIFICATION, enable: false })
      return
    }

    onOpen()

    if (notificationDraft) {
      form.setValue(name, notificationDraft)
    } else {
      form.setValue(name, { ...EMPTY_BUDGET_NOTIFICATION, enable: true })
    }
  }

  return (
    <div className={styles.section}>
      <Text tone="secondary" variant="body">
        <FormattedMessage {...messages.automations} />
      </Text>
      <div className={styles.card}>
        <Collapsible visible={Boolean(enable)}>
          <Collapsible.Header
            className={`${styles.cardRow} ${styles.clickableRow}`}
            onClick={() => handleEnable(!enable)}
          >
            <NotificationHeader name={name} form={form} />
          </Collapsible.Header>
          <Collapsible.Content>
            <NotificationContent name={name} form={form} />
          </Collapsible.Content>
        </Collapsible>
      </div>
    </div>
  )
}
